import {Component} from '@angular/core';
import {BaseComponent} from '../../base/base.component';

@Component({
  selector: 'app-base-ru-layout',
  templateUrl: './base-ru-layout.component.html',
})

export class BaseRuLayoutComponent extends BaseComponent {
}
